import Check from "../../icons/check";

export default function HFCheckbox({label, name, checked, onChange}: {
    label: string,
    name: string,
    checked: boolean,
    onChange: () => void
}) {
    return (
        <>
            <input type="checkbox" id={name} name={name} checked={checked} onChange={onChange}/>
            <label htmlFor={name}>
                <Check/>
            </label>
        </>
    );
}